const CHUNK_RELOAD_STORAGE_KEY = 'declarabid:chunk-reload-attempt';
const CHUNK_RELOAD_COOLDOWN_MS = 30000;

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk [\w-]+ failed/i,
  /ChunkLoadError/i,
];

function messageFromObject(value: unknown): string {
  if (!value || typeof value !== 'object') {
    return '';
  }

  const message = (value as { message?: unknown }).message;
  return typeof message === 'string' ? message : '';
}

function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }

  if (!error || typeof error !== 'object') {
    return '';
  }

  const reason = (error as { reason?: unknown }).reason;
  if (typeof reason === 'string') {
    return reason;
  }

  return messageFromObject(reason) || messageFromObject(error);
}

function isChunkLoadError(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (!message) {
    return false;
  }
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

function canAttemptReloadNow(): boolean {
  try {
    const previousAttemptRaw = sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY);
    if (!previousAttemptRaw) {
      return true;
    }

    const previousAttempt = Number(previousAttemptRaw);
    if (Number.isNaN(previousAttempt)) {
      return true;
    }

    return Date.now() - previousAttempt > CHUNK_RELOAD_COOLDOWN_MS;
  } catch {
    // If storage is unavailable, still attempt one hard reload.
    return true;
  }
}

function rememberReloadAttempt(): void {
  try {
    sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(Date.now()));
  } catch {
    // No-op: some browsers may block sessionStorage.
  }
}

export function handleChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  if (!canAttemptReloadNow()) {
    return false;
  }

  rememberReloadAttempt();
  globalThis.location.reload();
  return true;
}

